import React, { Component } from 'react'
import SostaOnlineApiService from '../../../../services/SostaOnlineApiService'
import moment from 'moment'
import DatePicker from 'react-datepicker'
import DropdownTreeSelect from 'react-dropdown-tree-select'
import TimePicker from 'react-time-picker'
import DropdownTreeSelectContainer from '../../../../components/DropdownTreeSelectContainer'
import {Field} from 'redux-form'

export default class Create extends Component {
  constructor (props) {
    super(props)
    this.state = {
      loading: false,
      submitting: false,
      errors: {},
      parkTicketTypes: [],
      categories: [],
      selectedCategories: [],
      start: null,
      startTime: '22:00',
      end: null,
      endTime: '23:59',
      availabilityNumber: 300,
      markStartDate: null,
      parkTicketTypeId: '',
      numberOfMonths: 1,
      parkTicketPrice: 0,
      circolazione: '',
      periodo: '',
      sosta: ''
    }
  }

  async componentDidMount () {
    this.setState({loading: true})
    await this.fetchParkTicketTypes()
    await this.fetchUserCategories()
    this.setState({loading: false})
  }

  onSubmit = async (e) => {
    e.preventDefault()
    this.setState({submitting: true, errors: {}, success: false})

    const startDate = moment(this.state.start)
    const startTime = moment(this.state.startTime, 'HH:mm')
    startDate.set({
      hour: startTime.get('hours'),
      minute: startTime.get('minutes'),
      second: 0
    })

    const endDate = moment(this.state.end)
    const endTime = moment(this.state.endTime, 'HH:mm')
    endDate.set({
      hour: endTime.get('hours'),
      minute: endTime.get('minutes'),
      second: 0
    })

    const waitingList = {
      startDate: startDate.format(),
      endDate: endDate.format(),
      availabilityNumber: this.state.availabilityNumber,
      markStartDate: this.state.markStartDate.format(),
      parkTicketTypeId: this.state.parkTicketTypeId,
      categories: this.state.selectedCategories.map(item => ({ id: item.id, parkTicketPrice: item.parkTicketPrice })),
      numberOfMonths: this.state.numberOfMonths,
      // parkTicketPrice: this.state.parkTicketPrice ? parseFloat(this.state.parkTicketPrice) : 0,
      circolazione: this.state.circolazione,
      periodo: this.state.periodo,
      sosta: this.state.sosta
    }
    const result = await SostaOnlineApiService.createWaitingList(waitingList)
    // const result = {result: 'ok'}

    if (result.result === 'ok') {
      this.setState({submitting: false, errors: {}, success: true})
      this.props.history.push('/backoffice/waiting-lists/' + result.data.id + '/summary')
    } else {
      this.setState({
        submitting: false,
        errors: {
          ...this.state.errors,
          submit: "Errore nella creazione della Lista d'Attesa"
        },
        success: false
      })
    }
  }

  mapCategories (items) {
    return items.map(item => {
      let children = null
      if (item.Children && item.Children.length > 0) {
        children = this.mapCategories(item.Children)
      }

      return {
        ...item,
        value: item.id,
        label: item.label.charAt(0).toUpperCase() + item.label.slice(1),
        children: children
      }
    })
  }

  checkCategories = (active, items) => {
    return items.map(item => {
      let isDefaultValue = false
      let children = []

      if (item.children && item.children.length > 0) {
        children = this.checkCategories(active, item.children)
      }
      if (active.filter(valueItem => item.id === valueItem.id).length > 0) {
        isDefaultValue = true
        console.log('dovrei farlo')
      }

      return {
        ...item,
        children: children,
        isDefaultValue: isDefaultValue,
        checked: isDefaultValue
      }
    })
  }

  async fetchUserCategories () {
    return SostaOnlineApiService.fetchUserCategories().then((data) => {
      this.setState({categories: this.mapCategories(data.data)})
    })
  }

  fetchParkTicketTypes () {
    SostaOnlineApiService.fetchParkTicketTypes().then((data) => {
      this.setState({
        parkTicketTypes: data.data
      })
    })
  }

  onChange = (event) => {
    const target = event.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name

    this.setState({
      [name]: value
    })

    if (name === 'parkTicketTypeId') {
      const parkTicketTypes = this.state.parkTicketTypes.filter(item => value == item.id)
      if (parkTicketTypes.length > 0) {
        const parkTicketType = parkTicketTypes[0]
        const totalPrice = parkTicketType.price * this.state.numberOfMonths

        this.setState({
          parkTicketPrice: totalPrice,
          selectedCategories: this.state.selectedCategories.map(item => ({
            ...item,
            parkTicketPrice: totalPrice
          })),
          circolazione: parkTicketType.circolazione,
          periodo: parkTicketType.periodo,
          sosta: parkTicketType.sosta
        })
      }
    }
  }

  onCategoryChange = (currentNode, selectedCategories) => {
    if (this.state.parkTicketTypeId) {
      const parkTicketTypes = this.state.parkTicketTypes.filter(item => this.state.parkTicketTypeId == item.id)
      const parkTicketType = parkTicketTypes[0]
      const totalPrice = parkTicketType.price * this.state.numberOfMonths

      this.setState({
        selectedCategories: selectedCategories.map((item, index) => {
          const foundedCategory = this.state.selectedCategories.filter(sC => sC.id === item.id)
          return {
            ...item,
            parkTicketPrice: foundedCategory.length > 0 ? foundedCategory[0].parkTicketPrice : totalPrice
          }
        })
      })
    } else {
      this.setState({selectedCategories: selectedCategories.map(item => ({
        ...item,
        parkTicketPrice: 0
      }))})
    }
  }

  onStartChange = (value) => {
    this.setState({start: value})
  }

  onStartTimeChange = (value) => {
    console.log(value)
    this.setState({startTime: value})
  }

  onEndChange = (value) => {
    this.setState({end: value})
  }

  onEndTimeChange = (value) => {
    console.log(value)
    this.setState({endTime: value})
  }

  onMarkStartDateChange = (value) => {
    this.setState({markStartDate: value})
  }

  onAddQuantity = () => {
    if (this.state.numberOfMonths >= 3) {
      return
    }

    const parkTicketType = this.state.parkTicketTypes.filter(item => this.state.parkTicketTypeId == item.id)
    const newQuantity = this.state.numberOfMonths + 2
    if (parkTicketType.length > 0) {
      const totalPrice = parkTicketType[0].price * newQuantity

      this.setState({
        numberOfMonths: newQuantity,
        parkTicketPrice: totalPrice
      })
    } else {
      this.setState({
        numberOfMonths: newQuantity
      })
    }
  }

  onRemoveQuantity = () => {
    if (this.state.numberOfMonths <= 1) {
      return
    }

    const parkTicketType = this.state.parkTicketTypes.filter(item => this.state.parkTicketTypeId == item.id)
    const newQuantity = this.state.numberOfMonths - 2
    if (parkTicketType.length > 0) {
      const totalPrice = parkTicketType[0].price * newQuantity

      this.setState({
        numberOfMonths: newQuantity,
        parkTicketPrice: totalPrice
      })
    } else {
      this.setState({
        numberOfMonths: newQuantity
      })
    }
  }

  onPriceChange = (category, e) => {
    this.setState({
      selectedCategories: this.state.selectedCategories.map(item => {
        if (item.id === category.id) {
          return {
            ...item,
            parkTicketPrice: e.target.value || 0
          }
        } else {
          return item
        }
      })
    })
  }

  render () {
    if (this.state.loading) {
      return (<div className="text-primary">Caricamento in corso...</div>)
    }

    return (
      <div className="panel panel-default panel-border">
        <div className="panel-body">
          <h2 className="title">Crea Lista d'Attesa</h2>
          <form onSubmit={this.onSubmit}>
            <div className="box">
              <fiedset>
                <div className="titolo-categoria">
                  <legend className="text-left">Impostazioni Lista d'Attesa</legend>
                </div>
              </fiedset>
              <div className="row" style={{marginBottom: 30}}>
                <div className="col-md-12 text-left">
                  <label>Seleziona categorie utente abilitate alla lista d'attesa</label>
                  <DropdownTreeSelectContainer
                    required
                    placeholderText={'Seleziona Categorie'}
                    data={this.state.categories}
                    onAction={({action, node}) => { console.log(`onAction:: [${action}]`, node) }}
                    onNodeToggle={(currentNode) => { console.log('onNodeToggle::', currentNode) }}
                    onChange={this.onCategoryChange}
                  />
                </div>
              </div>
              <div className="row" style={{marginBottom: 30}}>
                <div className="col-md-3 text-left">
                  <label>Data di apertura della lista</label>
                  <DatePicker
                    required
                    className="resident-login"
                    showTimeSelect
                    style={{width: '100%'}}
                    selected={this.state.start}
                    onChange={this.onStartChange}
                  />
                </div>
                {this.state.start && (
                  <div className="col-md-3 text-left">
                    <label>Orario di apertura della lista</label>
                    <TimePicker
                      value={'22:00'}
                      onChange={this.onStartTimeChange}
                    />
                  </div>
                )}
              </div>
              <div className="row" style={{marginBottom: 30}}>
                <div className="col-md-3 text-left">
                  <label>Data di chiusura della lista</label>
                  <DatePicker
                    required
                    showTimeSelect
                    className="resident-login"
                    selected={this.state.end}
                    onChange={this.onEndChange}
                  />
                </div>
                {this.state.end && (
                  <div className="col-md-3 text-left">
                    <label>Orario di chiusura della lista</label>
                    <TimePicker
                      value={'23:59'}
                      onChange={this.onEndTimeChange}
                    />
                  </div>
                )}
              </div>
              <div className="row" style={{marginBottom: 30}}>
                <div className="col-md-3 text-left">
                  <label>Numero di partecipanti massimi</label>
                  <input
                    value={this.state.availabilityNumber}
                    onChange={this.onChange}
                    type="number"
                    name="availabilityNumber"
                    className="form-control"
                  />
                </div>
              </div>
              <fiedset>
                <div className="titolo-categoria">
                  <legend className="text-left">Impostazioni Abbonamento generato dalla Lista</legend>
                </div>
              </fiedset>
              <div className="row" style={{marginBottom: 30}}>
                <div className="col-md-6 text-left">
                  <label>Tipo di abbonamento</label>
                  <select value={this.state.parkTicketTypeId} onChange={this.onChange} name="parkTicketTypeId" required className="form-control">
                    <option value={''}>Seleziona tipo Abbonamento</option>
                    {this.state.parkTicketTypes.map(item =>
                      <option key={item.id} value={item.id}>{item.name}</option>)}
                  </select>
                </div>
              </div>

              {this.state.parkTicketTypeId !== '' && (
                <div className="row" style={{marginBottom: 30}}>
                  <div className="col-md-2 text-left">
                    <label>Circolazione</label>
                    <input
                      value={this.state.circolazione}
                      onChange={this.onChange}
                      name="circolazione"
                      className="form-control"
                      type="text"
                    />
                  </div>
                  <div className="col-md-2 text-left">
                    <label>Periodo</label>
                    <input
                      value={this.state.periodo}
                      onChange={this.onChange}
                      name="periodo"
                      className="form-control"
                      type="text"
                    />
                  </div>
                  <div className="col-md-2 text-left">
                    <label>Sosta</label>
                    <input
                      value={this.state.sosta}
                      onChange={this.onChange}
                      name="sosta"
                      className="form-control"
                      type="text"
                    />
                  </div>
                </div>
              )}

              <div className="row" style={{marginBottom: 30}}>
                <div className="col-md-3 text-left">
                  <label>Mese di validità dell'abbonamento</label>
                  <DatePicker
                    required
                    className="resident-login"
                    style={{width: '100%'}}
                    selected={this.state.markStartDate}
                    onChange={this.onMarkStartDateChange}
                  />
                </div>

                <div className="col-md-3 text-left">
                  <label>Numero di mensilità:</label>
                  <div className="input-group" style={{marginBottom: '10px', marginTop: 4}}>
                    <span className="input-group-btn">
                      <button onClick={this.onRemoveQuantity} type="button" className="btn btn-default btn-number">
                        <span className="glyphicon glyphicon-minus">{}</span>
                      </button>
                    </span>
                    <input value={this.state.numberOfMonths} onChange={this.onChange} type="text" name="numberOfMonths" className="form-control" style={{padding: '6px', verticalAlign: 'middle', display: 'inline-block', textAlign: 'center', zIndex: '0'}} required />
                    <span className="input-group-btn">
                      <button onClick={this.onAddQuantity} type="button" className="btn btn-default btn-number">
                        <span className="glyphicon glyphicon-plus">{}</span>
                      </button>
                    </span>
                  </div>
                </div>

                {this.state.markStartDate && (
                  <div className="col-md-6 text-left">
                    <label>Validità Abbonamento</label>
                    <div style={{marginTop: 12}}>
                      <h4>
                        {
                          moment(this.state.markStartDate).startOf('month').format('L') +
                  ' - ' +
                  moment(this.state.markStartDate).add(this.state.numberOfMonths > 1 ? this.state.numberOfMonths - 1 : 0, 'months').endOf('month').format('L')
                        }
                      </h4>
                    </div>
                  </div>
                )}
              </div>

              {this.state.parkTicketTypeId && this.state.selectedCategories.map((item) => {
                return (
                  <div key={`waitinglist-parkticket-price-category-${item.id}`} className="row" style={{marginBottom: 30}}>
                    <div className="col-md-3 text-left">
                      <label>Prezzo per Categoria</label>
                      <h4 style={{paddingTop: '12px'}}>{item.description}</h4>
                    </div>
                    <div className="col-md-3 text-left">
                      <label>Prezzo per {item.description}</label>
                      <div className="input-group" style={{marginBottom: 12}}>
                        <div className="input-group-addon">€</div>
                        <input
                          name="parkTicketPrice"
                          type="number"
                          value={item.parkTicketPrice}
                          className="form-control"
                          onChange={e => { this.onPriceChange(item, e) }}
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="row">
                        <div className="col-md-6 text-left">
                          <label>Totale</label>
                          <div style={{marginTop: 12}}>
                            <h4>€ {Number(item.parkTicketPrice).toLocaleString('it-IT', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })}

              {this.state.submitting && <div className="text-primary">
                  Salvataggio in corso
              </div>}

              {this.state.error && <div className="text-danger">
                  Si sono verificati degli errori
              </div>}

              {this.state.success && <div className="text-success">
                  Salvataggio completato correttamente
              </div>}

              <p className="margin-btn-p">
                <button type="submit" className="btn btn-green">
                  Crea nuova Lista d'Attesa
                </button>
              </p>
            </div>
          </form>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Backoffice/BackofficeWaitingList/Create/Create.js